import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { sunoCommsApi } from "./api-base";
import {
  CallMetricsFilter,
  CallMetricsResponse,
} from "./types/call-metrics.type";

const callMetricsApi = sunoCommsApi.injectEndpoints({
  endpoints: (builder) => ({
    getCallMetrics: builder.query<CallMetricsResponse, CallMetricsFilter>({
      query: (params) =>
        `/metrics/${formatValidQueryParamUrlCommaSeparated(params, true)}`,
      providesTags: ["CallMetrics"],
    }),
  }),
});

export const { useGetCallMetricsQuery } = callMetricsApi;
